import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section-row" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, " Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. ", -1)
const _hoisted_3 = { class: "my-5 text-center" }
const _hoisted_4 = {
  class: "btn btn-primary me-lg-3 mb-3",
  href: "https://themes.3rdwavemedia.com/",
  target: "_blank"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" View Live Demo")
const _hoisted_6 = {
  class: "btn btn-secondary mb-3",
  href: "https://themes.3rdwavemedia.com/",
  target: "_blank"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" View on GitHub")
const _hoisted_8 = { class: "blockquote theme-blockquote text-center" }
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "mb-3 font-italic" }, " \"Walking on water and developing software from a specification are easy if both are frozen.\" ", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("footer", { class: "blockquote-footer mt-0" }, [
  /*#__PURE__*/_createVNode("cite", { title: "Source Title" }, "Edward V Berard")
], -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "section-row" }, [
  /*#__PURE__*/_createVNode("h3", { class: "section-title" }, "Heading Vestibulum Fringilla"),
  /*#__PURE__*/_createVNode("p", null, " Phasellus accumsan cursus velit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Sed aliquam, nisi quis porttitor congue, elit erat euismod orci, ac placerat dolor lectus quis orci. Phasellus consectetuer vestibulum elit. Aenean tellus metus, bibendum sed, posuere ac, mattis non, nunc. Vestibulum fringilla pede sit amet augue. In turpis. Pellentesque posuere. Praesent turpis. Aenean posuere, tortor sed cursus feugiat, nunc augue blandit nunc, eu sollicitudin urna dolor sagittis lacus. "),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" You can "),
    /*#__PURE__*/_createVNode("a", {
      href: "https://help.twitter.com/en/using-twitter/how-to-embed-a-tweet",
      target: "_blank"
    }, "embed a tweet"),
    /*#__PURE__*/_createTextVNode(" on your blog post: ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "mb-5 text-center" }, [
    /*#__PURE__*/_createVNode("blockquote", {
      class: "twitter-tweet",
      "data-lang": "en"
    }, [
      /*#__PURE__*/_createVNode("p", {
        lang: "en",
        dir: "ltr"
      }, " \"One of the best programming skills you can have is knowing when to walk away for awhile.\" - Oscar Godson "),
      /*#__PURE__*/_createTextVNode(" — Programming Wisdom (@CodeWisdom) "),
      /*#__PURE__*/_createVNode("a", { href: "https://twitter.com/CodeWisdom/status/841357948542713856?ref_src=twsrc%5Etfw" }, "March 13, 2017")
    ])
  ]),
  /*#__PURE__*/_createVNode("p", null, " Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. "),
  /*#__PURE__*/_createVNode("ul", { class: "mb-5 ms-md-5" }, [
    /*#__PURE__*/_createVNode("li", { class: "mb-4" }, [
      /*#__PURE__*/_createVNode("strong", null, "Lorem ipsum"),
      /*#__PURE__*/_createTextVNode(" dolor sit amet consectetuer. ")
    ]),
    /*#__PURE__*/_createVNode("li", { class: "mb-4" }, [
      /*#__PURE__*/_createVNode("strong", null, "Aenean"),
      /*#__PURE__*/_createTextVNode(" commodo ligula eget dolor.")
    ]),
    /*#__PURE__*/_createVNode("li", { class: "mb-4" }, [
      /*#__PURE__*/_createVNode("strong", null, "Aenean"),
      /*#__PURE__*/_createTextVNode(" massa cum sociis natoque penatibus. ")
    ]),
    /*#__PURE__*/_createVNode("li", { class: "mb-4" }, [
      /*#__PURE__*/_createVNode("strong", null, "Pellentesque"),
      /*#__PURE__*/_createTextVNode(" auctor neque nec urna.")
    ])
  ]),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Below are some code examples using the "),
    /*#__PURE__*/_createVNode("a", {
      class: "text-link",
      href: "https://highlightjs.org/",
      target: "_blank"
    }, "highlight.js"),
    /*#__PURE__*/_createTextVNode(" plugin. You can "),
    /*#__PURE__*/_createVNode("a", {
      class: "text-link",
      href: "https://highlightjs.org/download/",
      target: "_blank"
    }, "customise the script to include more languages"),
    /*#__PURE__*/_createTextVNode(" via their website if you need to. The stylesheet used in this template is "),
    /*#__PURE__*/_createVNode("code", null, "atom-one-dark.css")
  ]),
  /*#__PURE__*/_createVNode("h4", { class: "mb-3" }, "HTML Code Example"),
  /*#__PURE__*/_createVNode("div", { class: "mb-5" }, [
    /*#__PURE__*/_createVNode("pre", null, [
      /*#__PURE__*/_createVNode("code", { class: "html" }, "\n<div class=\"card\" style=\"width: 18rem;\">\n  <img class=\"card-img-top\" src=\"...\" alt=\"Card image cap\">\n  <div class=\"card-body\">\n    <h5 class=\"card-title\">Card title</h5>\n    <p class=\"card-text\">Some quick example text to build on the card title and make up the bulk of the card's content.</p>\n    <a href=\"#\" class=\"btn btn-primary\">Go somewhere</a>\n  </div>\n</div>\n\t\t\t    ")
    ])
  ]),
  /*#__PURE__*/_createVNode("h4", { class: "mb-3" }, "CSS Code Example"),
  /*#__PURE__*/_createVNode("div", { class: "mb-5" }, [
    /*#__PURE__*/_createVNode("pre", null, [
      /*#__PURE__*/_createVNode("code", { class: "css" }, "\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  text-align: left;\n  background-color: #fff;\n}\n\n\t\t    ")
    ])
  ]),
  /*#__PURE__*/_createVNode("h4", { class: "mb-3" }, "JavaScript Code Example"),
  /*#__PURE__*/_createVNode("div", { class: "mb-5" }, [
    /*#__PURE__*/_createVNode("pre", null, [
      /*#__PURE__*/_createVNode("code", { class: "javascript" }, "\n$(document).ready(function() {\n  $('pre code').each(function(i, block) {\n    hljs.highlightBlock(block);\n  });\n});\n\t\t\t    ")
    ])
  ]),
  /*#__PURE__*/_createVNode("h4", { class: "mb-3" }, "Responsive Video"),
  /*#__PURE__*/_createVNode("div", { class: "embed-responsive embed-responsive-16by9 mb-5" }, [
    /*#__PURE__*/_createVNode("iframe", {
      class: "embed-responsive-item",
      width: "560",
      height: "315",
      src: "https://www.youtube.com/embed/9aVJOg2EB9I?rel=0",
      frameborder: "0",
      allow: "autoplay; encrypted-media",
      allowfullscreen: ""
    })
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"section-row\"><h3 class=\"section-title\">Heading Inventore Veritatis Quasi</h3><p> Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. </p><figure class=\"figure mb-5\"><img class=\"img-fluid figure-img\" src=\"assets/images/blog/blog-post-image-example-1.png\"><figcaption class=\"figure-caption text-center\"> A caption for the above image. </figcaption></figure><p> At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime. </p><ol class=\"mb-5 ms-md-5\"><li class=\"mb-4\">Dolor sit amet consectetuer.</li><li class=\"mb-4\">Commodo ligula eget dolor.</li><li class=\"mb-4\">Massa cum sociis natoque penatibus.</li><li class=\"mb-4\">Auctor neque nec urna.</li><li class=\"mb-4\">Integer tincidunt.</li><li class=\"mb-4\">Ut varius tincidunt.</li></ol><p> Similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime. </p></div>", 1)
const _hoisted_13 = { class: "post-nav d-flex justify-content-between" }
const _hoisted_14 = { class: "nav-previous" }
const _hoisted_15 = {
  class: "text-link",
  href: "#",
  rel: "prev"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Previous ")
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "d-none d-md-inline" }, "Post", -1)
const _hoisted_18 = { class: "nav-next" }
const _hoisted_19 = {
  class: "text-link",
  href: "#",
  rel: "next"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Next ")
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "d-none d-md-inline" }, "Post", -1)
const _hoisted_22 = { class: "author-block my-5 bg-white p-4 p-l-5 shadow-sm" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "col-12 col-md-auto" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "author-profile profile-small d-inline-block rounded-circle",
    src: "assets/images/profile.png",
    alt: ""
  })
], -1)
const _hoisted_25 = { class: "col author-info" }
const _hoisted_26 = /*#__PURE__*/_createVNode("h4", { class: "mb-2 font-weight-bold" }, "Krzysztof Szumny", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "mb-3" }, " I'm a full stack developer with a passion for software development and UX. You can follow me via the various channels below: ", -1)
const _hoisted_28 = { class: "social-list-color list-inline mb-0" }
const _hoisted_29 = { class: "list-inline-item mb-3" }
const _hoisted_30 = {
  class: "twitter rounded-circle",
  href: "#"
}
const _hoisted_31 = { class: "list-inline-item mb-3" }
const _hoisted_32 = {
  class: "linkedin rounded-circle",
  href: "#"
}
const _hoisted_33 = { class: "list-inline-item mb-3" }
const _hoisted_34 = {
  class: "github rounded-circle",
  href: "#"
}
const _hoisted_35 = { class: "list-inline-item mb-3" }
const _hoisted_36 = {
  class: "stack-overflow rounded-circle",
  href: "#"
}
const _hoisted_37 = { class: "list-inline-item mb-3" }
const _hoisted_38 = {
  class: "medium rounded-circle",
  href: "#"
}
const _hoisted_39 = { class: "list-inline-item mb-3" }
const _hoisted_40 = {
  class: "codepen rounded-circle",
  href: "#"
}
const _hoisted_41 = { class: "list-inline-item mb-3" }
const _hoisted_42 = {
  class: "facebook rounded-circle",
  href: "#"
}
const _hoisted_43 = { class: "list-inline-item" }
const _hoisted_44 = {
  class: "instagram rounded-circle",
  href: "#"
}
const _hoisted_45 = /*#__PURE__*/_createVNode("div", {
  id: "comments-block",
  class: "comments-block"
}, [
  /*#__PURE__*/_createVNode("div", { id: "disqus_thread" }),
  /*#__PURE__*/_createVNode("a", {
    href: "http://disqus.com",
    class: "dsq-brlink"
  }, [
    /*#__PURE__*/_createTextVNode("comments powered by "),
    /*#__PURE__*/_createVNode("span", { class: "logo-disqus" }, "Disqus")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_font_awesome_layers = _resolveComponent("font-awesome-layers")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("p", _hoisted_3, [
        _createVNode("a", _hoisted_4, [
          _createVNode(_component_font_awesome_icon, {
            icon: "desktop",
            class: "me-2"
          }),
          _hoisted_5
        ]),
        _createVNode("a", _hoisted_6, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fab', 'github-alt'],
            class: "me-2"
          }),
          _hoisted_7
        ])
      ]),
      _createVNode("blockquote", _hoisted_8, [
        _createVNode(_component_font_awesome_layers, { class: "fa-fw mb-3" }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, {
              icon: "circle",
              class: "text-secondary",
              transform: "grow-12"
            }),
            _createVNode(_component_font_awesome_icon, {
              icon: "quote-right",
              class: "text-white",
              transform: "shrink-4"
            })
          ]),
          _: 1
        }),
        _hoisted_9,
        _hoisted_10
      ])
    ]),
    _hoisted_11,
    _hoisted_12,
    _createVNode("nav", _hoisted_13, [
      _createVNode("div", _hoisted_14, [
        _createVNode("a", _hoisted_15, [
          _createVNode(_component_font_awesome_icon, {
            icon: "long-arrow-alt-left",
            class: "me-1"
          }),
          _hoisted_16,
          _hoisted_17
        ])
      ]),
      _createVNode("div", _hoisted_18, [
        _createVNode("a", _hoisted_19, [
          _hoisted_20,
          _hoisted_21,
          _createVNode(_component_font_awesome_icon, {
            icon: "long-arrow-alt-right",
            class: "ms-1"
          })
        ])
      ])
    ]),
    _createVNode("div", _hoisted_22, [
      _createVNode("div", _hoisted_23, [
        _hoisted_24,
        _createVNode("div", _hoisted_25, [
          _hoisted_26,
          _hoisted_27,
          _createVNode("ul", _hoisted_28, [
            _createVNode("li", _hoisted_29, [
              _createVNode("a", _hoisted_30, [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['fab', 'twitter'],
                  class: "fa-fw"
                })
              ])
            ]),
            _createVNode("li", _hoisted_31, [
              _createVNode("a", _hoisted_32, [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['fab', 'linkedin'],
                  class: "fa-fw"
                })
              ])
            ]),
            _createVNode("li", _hoisted_33, [
              _createVNode("a", _hoisted_34, [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['fab', 'github-alt'],
                  class: "fa-fw"
                })
              ])
            ]),
            _createVNode("li", _hoisted_35, [
              _createVNode("a", _hoisted_36, [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['fab', 'stack-overflow'],
                  class: "fa-fw"
                })
              ])
            ]),
            _createVNode("li", _hoisted_37, [
              _createVNode("a", _hoisted_38, [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['fab', 'medium-m'],
                  class: "fa-fw"
                })
              ])
            ]),
            _createVNode("li", _hoisted_39, [
              _createVNode("a", _hoisted_40, [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['fab', 'codepen'],
                  class: "fa-fw"
                })
              ])
            ]),
            _createVNode("li", _hoisted_41, [
              _createVNode("a", _hoisted_42, [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['fab', 'facebook-f'],
                  class: "fa-fw"
                })
              ])
            ]),
            _createVNode("li", _hoisted_43, [
              _createVNode("a", _hoisted_44, [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['fab', 'instagram'],
                  class: "fa-fw"
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_45
  ], 64))
}